// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  firebase: {
    apiKey: "AIzaSyAMcZQmU0WvAuswz1VTDllIyQ9i2MeILdc",
    authDomain: "kronos.hiviewsolutions.com",
    databaseURL: "https://timesheet-f27f3.firebaseio.com",
    projectId: "timesheet-f27f3",
    storageBucket: "timesheet-f27f3.appspot.com",
    messagingSenderId: "956443200251",
    appId: "1:956443200251:web:7484c554594d8c91593e5e"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
